<template>
    <div :class="'product-item card product-card ' + (vg_user.role + '_product_card')">
        <div class="product-item-head">
            <div class="warranty-flag">
                <!-- request-->
                <img v-if="warrantyIcon == 'request' && ticketType == 'warranty'" src="@/assets/images/red-ribbon.png" alt="" />
                <img v-if="warrantyIcon == 'request' && ticketType == 'repair'" src="@/assets/images/repair_request_red.svg" alt="" />
                <!-- active-->
                <img v-if="warrantyIcon == 'active' && ticketType == 'warranty'" src="@/assets/images/active-warranty.png" alt="" />
                <img v-if="warrantyIcon == 'active' && ticketType == 'repair'" src="@/assets/images/repair_active_red.svg" alt="" />
                <!-- history-->
                <img v-if="warrantyIcon == 'history' && ticketType == 'warranty'" src="@/assets/images/history-warranty.png" alt="" />
                <img v-if="warrantyIcon == 'history' && ticketType == 'repair'" src="@/assets/images/repair_closed_red.svg" alt="" />
            </div>
            <a href="" @click.prevent="editcallback(product)" class="btn btn-primary card-view">VIEW</a>

            <a href="#" v-if="!hidedeletecallback" class="delete-action card-view" @click.prevent="deletecallback(product)">
                <i class="fa fa-trash" aria-hidden="true"></i>
            </a>
        </div>

        <div class="product-card-detail font-weight-bold text-center mt-3">
            <h3 class="mb-0">{{ product.sku_with_serial_number }}</h3>
            <p class="mb-3">{{ product.product_model }}</p>

            <template v-if="product.customer && product.customer.id">
                <p class="font-weight-bold mb-0">Customer</p>
                <ul class="reset">
                    <li>{{ product.customer.fname }} {{ product.customer.lname }}</li>
                    <li>{{ product.customer.email }}</li>
                    <li>{{ product.customer.phone }}</li>
                </ul>
            </template>

            <template
                v-if="
                    (type == 'superadmin' && product.reseller && product.reseller.id) ||
                    (type == 'distributor' && product.reseller && product.reseller.id)
                "
            >
                <p class="font-weight-bold mb-0 mt-3">Reseller</p>
                <ul class="reset">
                    <li>{{ product.reseller.company }}</li>
                    <li>{{ product.reseller.email }}</li>
                    <li>{{ product.reseller.phone }}</li>
                </ul>
            </template>

            <template
                v-if="
                    ((type == 'superadmin' || type == 'distributor') && product.distributor && product.distributor.id) ||
                    (type == 'reseller' && product.distributor && product.distributor.id)
                "
            >
                <p class="font-weight-bold mb-0 mt-3">Distributor</p>
                <ul class="reset">
                    <li>{{ product.distributor.company }}</li>
                    <li>{{ product.distributor.email }}</li>
                    <li>{{ product.distributor.phone }}</li>
                </ul>
            </template>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
    name: 'ProductItem',
    props: {
        type: {
            type: String,
            required: false
        },
        hidedeletecallback: {
            type: Boolean,
            required: false
        },
        product: {
            type: Object,
            required: true
        },
        editcallback: {
            type: Function,
            required: true
        },
        deletecallback: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            pdfdata: ''
        };
    },
    computed: {
        ticketType() {
            return this.product.ticket_type ? this.product.ticket_type : '';
        },
        warrantyIcon() {
            if (this.product.ticket_status == 'request') {
                return 'request';
            } else if (this.product.ticket_status == 'open') {
                return 'active';
            } else if (this.product.ticket_status == 'closed') {
                return 'history';
            }
            return '';
        },
        ...mapGetters({
            vg_user: 'auth/user'
        })
    },

    mounted() {},
    methods: {
        ...mapActions({
            va_modal: 'pdf/setActive',
            va_modalObj: 'pdf/setActiveObj'
        })
    }
};
</script>

<style scoped>
.product-card-action a {
    color: #ccc;
    border: 1px solid #ccc;
}
.product-card-action {
    display: flex;
    justify-content: flex-end;
}

.product-card {
    padding: 20px;
    border-radius: 5px;
    min-height: 400px;
}
.superadmin_product_card {
    min-height: 470px;
}
.product-card-action a {
    color: #353a3f;
    border: 1px solid #353a3f;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    font-size: 13px;
}
.product-card-action a:last-child {
    margin-left: 5px;
}
.product-card-action a:hover {
    color: #e70413;
    border: 1px solid #e70413;
}
.product-card-detail ul {
    padding-left: 0;
    list-style-type: none;
}
.warranty-active-flag img {
    width: 28px;
}
@media only screen and (max-width: 768px) {
    .superadmin-dashboard-area .product-card {
        min-height: auto;
        width: 350px;
        margin: 0 auto;
    }
}

@media only screen and (max-width: 400px) {
    .superadmin-dashboard-area .product-card {
        min-height: auto;
        width: 100%;
        margin: 0 auto;
    }
}
</style>
